export default __webpack_public_path__ + "static/media/i235hk.01c971ff.webp";